// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var ctx = React.createContext(/* Set18 */10);

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make = ctx.Provider;

var make$1 = React.memo(make);

var Provider = {
  makeProps: makeProps,
  make: make$1
};

function num(set) {
  switch (set) {
    case /* Set9 */0 :
        return 90;
    case /* Set95 */1 :
        return 95;
    case /* Set10 */2 :
        return 10;
    case /* Set11 */3 :
        return 110;
    case /* Set12 */4 :
        return 120;
    case /* Set13 */5 :
        return 130;
    case /* Set14 */6 :
        return 140;
    case /* Set15 */7 :
        return 150;
    case /* Set16 */8 :
        return 160;
    case /* Set17 */9 :
        return 170;
    case /* Set18 */10 :
        return 180;
    case /* Set36 */11 :
        return 36;
    case /* Set56 */12 :
        return 56;
    case /* Set76 */13 :
        return 76;
    case /* Set46 */14 :
        return 46;
    case /* Set101 */15 :
        return 101;
    case /* Set151 */16 :
        return 151;
    
  }
}

function num2(set) {
  switch (set) {
    case /* Set9 */0 :
        return 90;
    case /* Set95 */1 :
        return 95;
    case /* Set10 */2 :
        return 100;
    case /* Set11 */3 :
        return 110;
    case /* Set12 */4 :
        return 120;
    case /* Set13 */5 :
        return 130;
    case /* Set14 */6 :
        return 140;
    case /* Set15 */7 :
        return 150;
    case /* Set16 */8 :
        return 160;
    case /* Set17 */9 :
        return 170;
    case /* Set18 */10 :
        return 180;
    case /* Set36 */11 :
        return 36;
    case /* Set56 */12 :
        return 56;
    case /* Set76 */13 :
        return 76;
    case /* Set46 */14 :
        return 46;
    case /* Set101 */15 :
        return 101;
    case /* Set151 */16 :
        return 151;
    
  }
}

function fromNum(num) {
  if (num >= 111) {
    if (num < 141) {
      if (num !== 120) {
        if (num !== 130) {
          if (num >= 140) {
            return /* Set14 */6;
          } else {
            return /* Set11 */3;
          }
        } else {
          return /* Set13 */5;
        }
      } else {
        return /* Set12 */4;
      }
    }
    if (num === 170) {
      return /* Set17 */9;
    }
    if (num >= 161) {
      if (num !== 180) {
        return /* Set11 */3;
      } else {
        return /* Set18 */10;
      }
    }
    if (num < 150) {
      return /* Set11 */3;
    }
    switch (num) {
      case 150 :
          return /* Set15 */7;
      case 151 :
          return /* Set151 */16;
      case 152 :
      case 153 :
      case 154 :
      case 155 :
      case 156 :
      case 157 :
      case 158 :
      case 159 :
          return /* Set11 */3;
      case 160 :
          return /* Set16 */8;
      
    }
  } else {
    if (num < 47) {
      if (num !== 10) {
        if (num !== 36) {
          if (num >= 46) {
            return /* Set46 */14;
          } else {
            return /* Set11 */3;
          }
        } else {
          return /* Set36 */11;
        }
      } else {
        return /* Set10 */2;
      }
    }
    if (num === 56) {
      return /* Set56 */12;
    }
    if (num === 76) {
      return /* Set76 */13;
    }
    if (num < 90) {
      return /* Set11 */3;
    }
    switch (num) {
      case 90 :
          return /* Set9 */0;
      case 95 :
          return /* Set95 */1;
      case 100 :
          return /* Set10 */2;
      case 101 :
          return /* Set101 */15;
      case 91 :
      case 92 :
      case 93 :
      case 94 :
      case 96 :
      case 97 :
      case 98 :
      case 99 :
      case 102 :
      case 103 :
      case 104 :
      case 105 :
      case 106 :
      case 107 :
      case 108 :
      case 109 :
      case 110 :
          return /* Set11 */3;
      
    }
  }
}

function use(param) {
  var s = React.useContext(ctx);
  return num(s);
}

function useT(param) {
  return React.useContext(ctx);
}

export {
  ctx ,
  Provider ,
  num ,
  num2 ,
  fromNum ,
  use ,
  useT ,
  
}
/* ctx Not a pure module */
